module.exports = __webpack_public_path__ + "img/pr-11.246c1800.png";